/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';

import { FlagToggleHorizontal } from '../components/FlagToggle';
import TextAreaCardView from './healthEntry/components/TextAreaCardView';
import RouteNames from '../appAuthorized/RouteNames';

import { useNavigate } from '../hooks/useNavigate';
import { useNoteForActiveProfile } from '../hooks/useNote';

interface Props {
  match: any;
}
const NoteView: React.FC<Props> = (props) => {
  const isCreating = props.match.params.noteId === 'create';
  const noteId = isCreating ? null : Number(props.match.params.noteId);

  const [state, setState] = React.useState({
    noteData: { content: '', flagged: false },
    isSubmitting: false,
  });

  const [, navActions] = useNavigate();
  const [{ note, ...noteData }, noteActions] = useNoteForActiveProfile(noteId);
  const isValid = state.noteData.content.length > 0;
  const isLoaded = noteData.isLoaded || isCreating;

  const goBack = () => {
    navActions.goBackTo(RouteNames.myBackpackNotes());
  };

  React.useEffect(() => {
    if (isLoaded) {
      setState({
        ...state,
        noteData: note,
      });
    }
  }, [isLoaded]);

  if (!isLoaded) { return null; }

  return (
    <TextAreaCardView
      value={state.noteData.content}
      placeholderPhrase=""
      hasInitialFocus={isCreating}
      isCreating={isCreating}
      onSubmit={() => {
        setState({ ...state, isSubmitting: true });

        if (!noteActions.hasChanges(state.noteData)) {
          goBack();
        } else if (isCreating) {
          noteActions.apiCreate(state.noteData)
            .then(goBack)
            .catch(() => {
              setState({ ...state, isSubmitting: false });
            });
        } else {
          noteActions.apiUpdate(state.noteData)
            .then(goBack)
            .catch(() => {
              setState({ ...state, isSubmitting: false });
            });
        }
      }}
      onChange={(value) => {
        const newNote = noteActions.instantiateNote(state.noteData);
        newNote.setContent(value);
        setState({
          ...state,
          noteData: newNote.data,
        });
      }}
      isValid={isValid}
      isSubmitting={state.isSubmitting}
      onCancel={goBack}
      onDelete={() => {
        const newNote = noteActions.instantiateNote(state.noteData);

        if (isCreating && !newNote.getContent()) {
          goBack();
        } else {
          noteActions.apiDelete()
            .then(goBack);
        }
      }}
      loadInitialData={() => {}}
      footerLeftContent={(
        <FlagToggleHorizontal
          isFlagged={state.noteData.flagged}
          onClick={() => {
            const newNote = noteActions.instantiateNote(state.noteData);
            newNote.toggleFlagged();

            setState({
              ...state,
              noteData: newNote.data,
            });
          }}
          colorTheme="gsMedDark"
        />
      )}
      additionalCardContent={null}
    />
  );
};

export default NoteView;
